import { render, staticRenderFns } from "./PopupOrder.vue?vue&type=template&id=1b0763bb&scoped=true&"
import script from "./PopupOrder.vue?vue&type=script&lang=js&"
export * from "./PopupOrder.vue?vue&type=script&lang=js&"
import style0 from "./PopupOrder.vue?vue&type=style&index=0&id=1b0763bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0763bb",
  null
  
)

export default component.exports